import BrandBible from "./marketing/components/BrandBible";

export default function BusinessBiblePage() {
  return (
    <div className="min-h-screen px-6 md:px-12 lg:px-16 py-10 bg-stone-50">
      <BrandBible />
    </div>
  );
}
